import * as React from "react";
import type { RibbonIconPreviewGalleryProps } from "./RibbonIconPreviewGallery.types";
import { useRibbonIconPreviewGallery } from "./useRibbonIconPreviewGallery";
import { renderRibbonIconPreviewGallery } from "./renderRibbonIconPreviewGallery";
import type { ForwardRefComponent } from "@fluentui/react-components";

export const RibbonIconPreviewGallery: ForwardRefComponent<RibbonIconPreviewGalleryProps> =
  React.memo(
    React.forwardRef<HTMLDivElement, RibbonIconPreviewGalleryProps>(
      (props, ref) => {
        const state = useRibbonIconPreviewGallery(props, ref);
        return renderRibbonIconPreviewGallery(state);
      }
    ) as ForwardRefComponent<RibbonIconPreviewGalleryProps>
  );
